import * as Images from "./images";

export const StaticURLs = {
	Images,
};
